export enum TileColor {
  Wetland = 'wetland',
  Forest = 'forest',
  Alpine = 'alpine',
  Coral = 'coral',
  Savanna = 'savanna',
}

export enum TileSymbol {
  Moss = 'moss',
  Fern = 'fern',
  Flower = 'flower',
  Mushroom = 'mushroom',
  Shell = 'shell',
  Vine = 'vine',
}

export interface TileType {
  color: TileColor;
  symbol: TileSymbol;
}

export const SACRED_SPRING = 'sacred-spring';
export type SacredSpring = typeof SACRED_SPRING;

export const SEED_TILE = 'seed';
export type SeedTile = typeof SEED_TILE;

export const WAVE_TILE = 'wave';
export type WaveTile = typeof WAVE_TILE;

export type PlaceableTile = TileType | SacredSpring | SeedTile | WaveTile;

export function isSacredSpring(tile: PlaceableTile): tile is SacredSpring {
  return tile === SACRED_SPRING;
}

export function isSeedTile(tile: PlaceableTile): tile is SeedTile {
  return tile === SEED_TILE;
}

export function isWaveTile(tile: PlaceableTile): tile is WaveTile {
  return tile === WAVE_TILE;
}

export function tilesMatch(a: PlaceableTile, b: PlaceableTile): boolean {
  if (isSacredSpring(a) || isSacredSpring(b)) return true;
  if (isSeedTile(a) || isSeedTile(b)) return true;
  if (isWaveTile(a) || isWaveTile(b)) return true;
  return a.color === b.color || a.symbol === b.symbol;
}

export const ALL_COLORS = Object.values(TileColor);
export const ALL_SYMBOLS = Object.values(TileSymbol);

export function tileAssetKey(tile: PlaceableTile): string {
  if (isSacredSpring(tile)) return SACRED_SPRING;
  if (isSeedTile(tile)) return SEED_TILE;
  if (isWaveTile(tile)) return WAVE_TILE;
  return `${tile.symbol}-${tile.color}`;
}
